import url from './url'

const AppConsts = {
    userManagement: {
        defaultAdminUserName: 'admin'
    },
    localization: {
        defaultLocalizationSourceName: 'AbpUi',
        UI: {
            oneRecordAtLeast: '请至少选择一条记录',
            saveSuccess: "保存成功！",
            saveFailed: "保存失败！",
            updateSuccess: "更新成功！",
            deleteSuccess: "删除成功！",
            deleteFailed: "删除异常,可能有部分数据删除失败",
        }
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token'
    },
    apiBaseUrl: url,
    //内网配置
    // socketServer:'ws://127.0.0.1:10201/ws',
    // appBaseUrl: "http://localhost:8080",
    // mapServerUrl:'http://192.168.1.247:1601',
    //公网配置
    socketServer: 'ws://xf.geofly.com.cn:10201/ws',
    appBaseUrl: "http://xf.geofly.com.cn:8080",
    //文件资源地址
    // fileResourceUrl: 'http://192.168.1.247:8082',
    fileResourceUrl: 'https://www.yntrxxh.com',

    //oauth认证配置，暂时未使用.
    oAuthConfig: {
        authority: "http://localhost:5000",
        client_id: "public-website-client",
        redirect_uri: "http://localhost:5003/callback.html",
        response_type: "code",
        scope: "openid profile PublicWebSiteGateway",
        post_logout_redirect_uri: "http://localhost:5003/index.html",
    },
    authConfig: {
        //内网地址
        //认证服务器URL
        // authUrl: "http://192.168.1.247:730/",
        //认证服务器API URL
        // authApiUrl: 'http://192.168.1.247:731/',

        //外网地址
        authUrl: "http://xf.geofly.com.cn:10086/",
        // authApiUrl: 'http://xf.geofly.com.cn:731/',
        clientId: 'public-website-client',
        clientsecret: '1q2w3e*'
    },
    remoteServiceBaseUrl: url,
    events: {
        tdlz: {
            updateLZDKEditWin: "updateLZDKEditWin", //更新流转地块
            openLZDKEditWin: "openLZDKEditWin", //打开流转地块
            savedLZDKEditWin: "savedLZDKEditWin", //流转地块窗口保存成功时

            updateBCDJEditWin: "updateBCDJEditWin", //更新补偿登记窗口

            //流转地块导入数据
            updateLZDKDREditWin: "updateLZDKDREditWin", //更新流转地块
            openLZDKDREditWin: "openLZDKDREditWin", //打开流转地块
            savedLZDKDREditWin: "savedLZDKDREditWin", //流转地块窗口保存成功时

            updateQLREditWin: "updateQLREditWin", //更新权利人
            openQLREditWin: "openQLREditWin", //打开权利人
            savedQLREditWin: "savedQLREditWin", //权利人窗口保存成功时
            updateDKGLEditWin: "updateDKGLEditWin", //更新地块管理窗口信息
            openDKGLEditWin: "openDKGLEditWin", // 打开地块管理编辑窗口
            savedDKGLEditWin: "savedDKGLEditWin", //保存地块管理信息

            updateJTCYEditWin: "updateJTCYEditWin", //更新家庭成员编辑窗口信息
            openJTCYEditWin: "openJTCYEditWin", // 打开家庭成员编辑窗口
            savedJTCYEditWin: "savedJTCYEditWin", //保存家庭成员信息


            updateZXLZFundEditWin0: "updateZXLZFundEditWin0", //更新地块管理窗口信息
            openZXLZFundEditWin0: "openZXLZFundEditWin0", // 打开地块管理编辑窗口
            savedZXLZFundEditWin0: "savedZXLZFundEditWin0", //保存地块管理信息

            updateZXLZFundEditWin: "updateZXLZFundEditWin", //更新地块管理窗口信息
            openZXLZFundEditWin: "openZXLZFundEditWin", // 打开地块管理编辑窗口
            savedZXLZFundEditWin: "savedZXLZFundEditWin", //保存地块管理信息

            //地图相关
            mapDKGLCancelDraw: "mapDKGLCancelDraw", //取消地块管理绘制
            mapDKGLEditLoadData: 'mapDKGLLoadData', //地块管理加载数据
            mapDKGLShowLoadData: 'mapDKGLShowLoadData', //地块管理
            mapDKGLShowLocated: 'mapDKGLShowLocated', //地块管理
            mapDKGLShowHover: 'mapDKGLShowHover', //地块管理
            mapLZDKShowLoadData: 'mapLZDKShowLoadData', //轮转地块地图数据加载事件
            mapLZDKSelect: 'mapLZDKSelect', //轮转地块地图数据加载事件
            mapLzybcdjDkSelected: 'mapLzybcdjDkSelected' //流转与补偿登记页面地图选中

        },
        shbzbzgl: {
            updateZYJSEditWin: "updateZYJSEditWin", //更新就业介绍
            openZYJSEditWin: "openZYJSEditWin", //打开就业介绍
            savedZYJSEditWin: "savedZYJSEditWin", //就业介绍窗口保存成功时

            //培训指导
            updatePXZDEditWin: "updatePXZDEditWin", //更新
            openPXZDEditWin: "openPXZDEditWin", //打开
            savedPXZDEditWin: "savedPXZDEditWin", //保存成功


            //培训-考核
            updatePXKHEditWin: "updatePXKHEditWin", //更新
            openPXKHEditWin: "openPXKHEditWin", //打开
            savedPXKHEditWin: "savedPXKHEditWin", //保存成功
            //培训-报名
            updatePXBMEditWin: "updatePXBMEditWin", //更新
            openPXBMEditWin: "openPXBMEditWin", //打开
            savedPXBMEditWin: "savedPXBMEditWin", //保存成功
            //培训-培训课程登记
            updatePXDJEditWin: "updatePXDJEditWin", //更新
            openPXDJEditWin: "openPXDJEditWin", //打开
            savedPXDJEditWin: "savedPXDJEditWin", //保存成功
            //报名登记选择
            updateBMDJSelectWin: 'updateBMDJSelectWin', //更新
            openBMDJSelectWin: "openBMDJSelectWin", //打开

            //通知接收人选择
            updateTZJSRSelectWin: 'updateTZJSRSelectWin', //更新
            openTZJSRSelectWin: "openTZJSRSelectWin", //打开
            //通知接收人编辑
            updateTZJSREditWin: "updateTZJSREditWin", //更新
            openTZJSREditWin: "openTZJSREditWin", //打开
            savedTZJSREditWin: "savedTZJSREditWin", //保存成功
            //培训通知
            updatePXTZEditWin: "updatePXTZEditWin", //更新
            openPXTZEditWin: "openPXTZEditWin", //打开
            savedPXTZEditWin: "savedPXTZEditWin", //保存成功
            //编辑通知接收者
            updateBJTZJSZEditWin: "updateBJTZJSZEditWin", //更新
            openBJTZJSZEditWin: "openBJTZJSZEditWin", //打开
            savedBJTZJSZEditWin: "savedBJTZJSZEditWin", //保存成功

        },
        xglz: {
            //规划辅助
            updateGHFZEditWin: "updateGHFZEditWin", //更新
            openGHFZEditWin: "openGHFZEditWin", //打开
            savedGHFZEditWin: "savedGHFZEditWin", //保存
            canceledGHFZEditWin: "canceledGHFZEditWin", //取消
            //规划辅助查看
            updateGHFZViewWin: "updateGHFZViewWin", //更新
            openGHFZViewWin: "openGHFZViewWin", //打开

            //招商引资
            updateZSYZEditWin: "updateZSYZEditWin", //更新
            openZSYZEditWin: "openZSYZEditWin", //打开
            savedZSYZEditWin: "savedZSYZEditWin", //保存
            canceledZSYZEditWin: "canceledZSYZEditWin", //取消
            //招商引资查看
            updateZSYZViewWin: "updateZSYZViewWin", //更新
            openZSYZViewWin: "openZSYZViewWin", //打开

            //企业信息
            updateQYXXEditWin: "updateQYXXEditWin", //更新
            openQYXXEditWin: "openQYXXEditWin", //打开
            savedQYXXEditWin: "savedQYXXEditWin", //保存

            //选择企业信息
            updateQYXXSelWin: "updateQYXXSelWin", //更新
            openQYXXSelWin: "openQYXXSelWin", //打开
            savedQYXXSelWin: "savedQYXXSelWin", //保存


            //休耕轮作
            updateXGLZEditWin: "updateXGLZEditWin", //更新
            openXGLZEditWin: "openXGLZEditWin", //打开
            savedXGLZEditWin: "savedXGLZEditWin", //保存
            canceledXGLZEditWin: "canceledXGLZEditWin", //保存

            updateXGLZViewWin: "updateXGLZViewWin", //更新
            openXGLZViewWin: "openXGLZViewWin", //打开


            updateXGLZQLRViewWin: "updateXGLZQLRViewWin", //更新
            openXGLZQLRViewWin: "openXGLZQLRViewWin", //打开

            //联系人
            updateLXREditWin: "updateLXREditWin", //更新
            openLXREditWin: "openLXREditWin", //打开
            savedLXREditWin: "savedLXREditWin", //保存


            //地图相关
            mapFZGHStartEdit: "mapFZGHStartEdit", //辅助规划开启地图编辑
            mapFZGHDateUpdate: "mapFZGHDataUpdate", //辅助规划数据更新
            mapFZGHSetData: 'mapFZGHSetData',//设置重点地块数据
            mapFZGHHoverItem: 'mapFZGHHoverItem', //高亮特定项目
            mapFZGHHoverAndLocateItem: 'mapFZGHHoverAndLocateItem', //高亮并定位项目
            mapFZGHSetRefXMID: 'mapFZGHSetRefXMID' //设置关联项目ID
            // mapFZGHStartEdit: "mapFZGHStartEdit", //辅助规划开启地图编辑
            // mapFZGHLoadData: 'mapDKGLLoadData', //地块管理加载数据
            // mapFZGHLoadData: 'mapDKGLShowLoadData', //地块管理
            // mapFZGHLoadData: 'mapLZDKShowLoadData', //轮转地块地图数据加载事件

        }
    },

    pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        defaultPageSize: 10,
        showTotal: (total, range) => `第 ${range[0]} - ${range[1]} 条记录，共 ${total} 条记录`,
        showLessItems: true,
        showSizeChanger: true,
        showQuickJumper: true,
    },
    rateDic: {
        '元': 100,
        '万元': 1000000,
        '亩': 1,
        '平方米': 0.0001
    },
    avatarUrl: 'http://img0.imgtn.bdimg.com/it/u=3741733804,1966033566&fm=26&gp=0.jpg'//默认头像
}
export default AppConsts


export const EMPTY_ARRAY = () => {
    return []
}

export const EMPTY_OBJECT = () => {
    return {}
}


export enum dicType {
    '所有权性质' = '01',
    '地力等级' = '02',
    '土地用途' = '03',
    '证件类型' = '04',
    '承包方类型' = '05',
    '性别' = '06',
    '成员备注' = '07',
    '附件文件类别' = '08',
    '权利人类型' = '09',
    '承包方式' = '10',
    '土地利用类型' = '11',
    '与户主关系' = '12',
    '费用类别' = '13',
    '违规类型' = '14',
    '病虫害程度' = '15',
    '病虫害类型' = '16',
    '采样层次' = '17',
    '成土母质' = '18',
    // '地力等级' = '19',
    '地形部位' = '20',
    '地形类型' = '21',
    '典型作物生长阶段' = '22',
    '肥料类型' = '23',
    '肥料养分类型' = '24',
    '粪便利用方式' = '25',
    '灌溉方式' = '26',
    '灌溉能力' = '27',
    '灌溉水类型' = '28',
    '检测项目' = '29',
    '秸秆综合利用' = '31',
    '农膜类型' = '32',
    '农药类型' = '33',
    '农作物品种' = '34',
    '排水能力' = '35',
    '坡度' = '36',
    '施肥方式' = '37',
    '施药方式' = '38',
    '土地类型' = '39',
    '土壤含水率测法' = '40',
    '土壤类型' = '41',
    '土壤湿度' = '42',
    '土壤系统分类' = '43',
    '土壤颜色' = '44',
    '土壤质地' = '45',
    '样品类型' = '46',
    '作物水分状态' = '47',
    '残渣主要利用方式' = '48',
    '发电站类型' = '49',
    '防治方式' = '50',
    '回收站类型' = '51',
    '主体处理工艺' = '52'
}

//验证状态
export enum validateStatus {
    'success' = 'success',
    'warning' = 'warning',
    'error' = 'error',
    'validating' = 'validating'
}

export interface exElement extends Element {
    init: Function,
    add: Function,
    edit: Function,
    active: Function,
    delete: Function,
    detail: Function,
    open: Function
}

//查询参数
export interface queryParameters {
    pagenumber: number,
    pagesize: number,
    keywords: string,
    objectid: string,
    xzqcode: string,
    sorting: string,
    skipcount: number,
    maxresultcount: number
}

export interface selectOption {
    children: Array<any>,
    content: object,
    disabled: boolean,
    key: string,
    title: string,
    value: string,
}

//附件
export interface attachment {
    id: string,
    scsj: Date,
    wjdx: string,
    wjlj: string,
    wjlx: string,
    wjmc: string
}



